const JSON_CONTENT_TYPE = "application/json";

export const postJson = async <TResponse>({
  url,
  body,
}: {
  url: string;
  body: unknown;
}): Promise<TResponse | null> => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": JSON_CONTENT_TYPE },
      body: JSON.stringify(body),
    });

    if (!response.ok) return null;

    return (await response.json()) as TResponse;
  } catch {
    return null;
  }
};

const queueBeacon = ({ url, payload }: { url: string; payload: string }): boolean => {
  if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") return false;

  try {
    return navigator.sendBeacon(url, new Blob([payload], { type: JSON_CONTENT_TYPE }));
  } catch {
    return false;
  }
};

export const sendBeaconJson = ({ url, body }: { url: string; body: unknown }): void => {
  const payload = JSON.stringify(body);

  if (queueBeacon({ url, payload })) return;

  try {
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": JSON_CONTENT_TYPE },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch {
    return;
  }
};
